'use strict';

(function ($, Drupal, drupalSettings) {
    Drupal.behaviors.menuExpand = {
        attach: function (context, settings) {
            $('.menu-item--expanded', context).hover(
                function (e) {
                    $('header').removeClass('hover').addClass('hover')
                },
                function (e) {
                    $('header').removeClass('hover');
                }
            );
        }
    };

    Drupal.behaviors.videoSlider = {
        attach: function (context, settings) {
            $('.video-slider', context).each(function() {
                var $feature = $(this),
                    $sliderVideo = $('.js-video-slider', $(this));

                var screenWidth = (window.innerWidth > 0) ? window.innerWidth : screen.width;
                if (screenWidth > 900) {
                    var slides = 7;
                } else if (screenWidth > 600) {
                    var slides = 5;
                } else if (screenWidth > 450) {
                    var slides = 3;
                } else {
                    var slides = 2;
                }
                $('.js-video-slider').slick({
                    slidesToShow: slides,
                    arrows      : false,
                    dots        : false
                });

                $('.js-prev-alt', $(this)).on('click', function (e) {
                    e.preventDefault();
                    $sliderVideo.slick('slickPrev');
                });

                $('.js-next-alt', $(this)).on('click', function (e) {
                    e.preventDefault();
                    $sliderVideo.slick('slickNext');
                });

                $sliderVideo.on('click', 'a', function (e) {
                    if (!$(this).hasClass('embed-disabled')) {
                        e.preventDefault();
                        $('.embed-container iframe', $feature).attr('src', 'https://www.youtube.com/embed/' + $(this).data('id'));
                        $('.video-slider__featured h6', $feature).html($(this).attr('data-title'));
                    }
                });
            });
        }
    };

    Drupal.behaviors.burger = {
        attach: function (context, settings) {
            $('.menu-open', context).on('click', function (e) {
                e.preventDefault();
                $('.navburger').toggleClass('opened');
            });
        }
    }
})(jQuery, Drupal, drupalSettings);
